import React, { useEffect, useState } from "react";
import basicIcon from "../assets/images/settings_page_icons/basicicon.png";
import proIcon from "../assets/images/settings_page_icons/proicon.png";
import premiumIcon from "../assets/images/settings_page_icons/premiumicon.png";
import enterpriseIcon from "../assets/images/settings_page_icons/enterpriseicon.png";
import {
  COUPON_APPLY,
  PACKAGES_LISTING,
  GET_USER,
  CANCEL_SUBSCRIPTION,
  GET_USER_SUBSCRIPTION,
  TRANSACTION,
} from "../utils/constants/apiUrl";
import useFunctionsCount from "../hooks/useFunctionsCount";
import { get } from "../server";
import {
  loggedInUser,
  subscribedPackage,
  teamSubscribedPackage,
  accountType,
  isOwnerPackage,
  teamIDCheck,
  userIDCheck,
} from "../utils/store";
import { useAtom } from "jotai";
import Loader from "../components/Loader";
import showToast from "../helpers/showToast";
import { loadStripe } from "@stripe/stripe-js";
import SubscriptionModal from "../components/Modals/SubscriptionModal";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import useLogout from "../hooks/useLogout";
import { AiFillCheckCircle } from "react-icons/ai";
import { post } from "../server";
import { MdSend } from "react-icons/md";
import { Button, Card, Modal } from "react-bootstrap";
import { MdClose } from "react-icons/md";
import { trackEvent } from "../utils/mixpanel";
import {
  elementsOptions,
  stripePromise,
} from "../utils/constants/stripeConfig";
import SubscriptionCard from "../components/SubscriptionCard";
import { normalizePackageDetails } from "../utils/functions";

const Subscription = () => {
  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedPackage, setSelectedPackage] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [purchasedPackage, setPurchasedPackage] = useAtom(subscribedPackage);
  const [teamPurchasedPackage, setTeamPurchasedPackage] = useAtom(teamSubscribedPackage);
  const [packageSubscribed, setPackageSubscribed] = useAtom(subscribedPackage);
  const [personalAccount, setPersonalAccount] = useAtom(accountType);
  const [isOwnerPackageActive, setIsOwnerPackageActive] =
    useAtom(isOwnerPackage);
  const [userTeamId, setUserTeamId] = useAtom(teamIDCheck);
  const [userID, setUserID] = useAtom(userIDCheck);
  const { userActions } = useFunctionsCount();
  const [activeKeys, setActiveKeys] = useState([]);
  const [hasCoupon, setHasCoupon] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [correctCouponEntered, setCorrectCouponEntered] = useState(false);
  const [incorrectCouponEntered, setIncorrectCouponEntered] = useState(false);
  const [showCouponInputs, setShowCouponInputs] = useState({});
  const [couponData, setCouponData] = useState("");
  const [coupons, setCoupons] = useState({});
  // ownedpackageId is derived from the persisted teamPurchasedPackage atom
  // so it survives page reload, navigation, and re-login
  const ownedpackageId = teamPurchasedPackage?.id ?? null;
  const [blankCouponField, setBlankCouponField] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const location = useLocation();
  const logout = useLogout();
  const navigate = useNavigate();
  const { teamId } = useParams();
  const creationDate = new Date(purchasedPackage?.end_date);
  const currentDate = new Date();
  // Compare the current date with the end_date
  const isExpired = creationDate < currentDate;
  const formattedDate = creationDate.toLocaleString();
  // const handleCheckboxChange = () => {
  //   setHasCoupon((prev) => !prev);
  // };
  const handleCheckboxChange = (packageId) => {
    setShowCouponInputs((prev) => ({
      ...prev,
      [packageId]: !prev[packageId],
    }));
  };

  const handleCouponInputChange = (event) => {
    setCouponCode(event.target.value);
  };

  const handleTabSelect = (subscriptionIndex, key) => {
    setActiveKeys((prevActiveKeys) => {
      // Create a copy of the previous activeKeys array
      const updatedActiveKeys = [...prevActiveKeys];
      // Update the active key for the corresponding subscription
      updatedActiveKeys[subscriptionIndex] = key;
      return updatedActiveKeys;
    });
  };

  // Handle Logout
  const handleLogout = () => {
    logout();
  };

  const applyCoupon = async (subscriptionType, packageId) => {
    if (!couponCode) {
      setBlankCouponField(true);
      return;
    }
    // setLoading(true);
    setCorrectCouponEntered(false);
    setIncorrectCouponEntered(false);

    const payload = {
      package_id: packageId,
      coupon_code: couponCode,
      subscription_type: subscriptionType,
    };

    let { status, message, data } = await post(
      COUPON_APPLY,
      payload,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    if (status) {
      setCorrectCouponEntered(true);
      setCouponData(data);
    } else {
      setIncorrectCouponEntered(true);
    }
  };
  const getSubscriptionDetails = async () => {
    let { status, message, data } = await get(
      GET_USER,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );

    if (status) {
      if (data) {
        data.token = loggedUser.token;
        data = normalizePackageDetails(data);
        setLoggedUser(data);
        userActions(data);
      }
      if (data && data.package_details && data.package_details.length > 0) {
        let teamPackage = null;
        if (userTeamId) {
          teamPackage = data.package_details.find(
            (pkg) => pkg.team_id == userTeamId
          );
        }
        if (!teamPackage && data.teams?.id) {
          teamPackage = data.package_details.find(
            (pkg) => pkg.team_id == data.teams.id
          );
        }
        if (!teamPackage) {
          teamPackage = data.package_details.find(
            (pkg) => pkg.team_id !== null
          );
        }
        if (!teamPackage) {
          teamPackage = data.package_details.find(
            (pkg) => pkg.is_team_owner === 1
          );
        }
        // ownedpackageId is now derived from teamPurchasedPackage atom — no local state needed
      }
    } else {
      showToast(status, message);
      navigate("/");
    }
  };
  const getSubscriptionPackageDetails = async () => {
    const payload = {
      user_id: userID,
      team_id: userTeamId,
    };
    let { status, message, data } = await post(
      GET_USER_SUBSCRIPTION,
      payload,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );

    if (status) {
      const subscription = data[0];
      const pkg = subscription?.package || null;
      // Set both atoms so the state persists across reloads/re-logins
      setPurchasedPackage(pkg);
      setTeamPurchasedPackage(pkg);
    } else {
      showToast(status, message);
    }
  };
  // Load singlePackage data
  const loadSubscriptions = async () => {
    // if (!userTeamId) {
    //   showToast(false, "Team ID is required to load subscriptions.");
    //   return;
    // }
    setLoading(true);
    const queryString = `?user_id=${userID}&team_id=${userTeamId}`;
    if (userTeamId) {
      let { status, message, data } = await get(
        PACKAGES_LISTING + queryString,
        Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
      );

      if (status) {
        if (data) {
          let ownerpackages = data.filter(
            // (singlePackage) => singlePackage.package_type == "owner"
            (singlePackage) =>
              singlePackage.package_type === "owner" ||
              singlePackage.package_type === "customer_specific_owner"
          );
          setSubscriptions(ownerpackages);
        }
      } else {
        showToast(status, message);
      }
    }
    setLoading(false);
  };

  // const loadCoupons = async () => {
  //   setLoading(true);
  //   let { status, message, data } = await get(
  //     COUPON,
  //     Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
  //   );
  //   if (status) {
  //     if (data.length > 0) {
  //       setCoupons(data);
  //     }
  //   } else {
  //     showToast(status, message);
  //   }
  //   setLoading(false);
  // };

  useEffect(() => {
    if (userTeamId && userID) {
      loadSubscriptions();
    }
    getSubscriptionDetails();
    getSubscriptionPackageDetails();
  }, [userTeamId, userID]);

  if (loading) {
    return <Loader />;
  }
  const handleCloseModal = async (purchaseSuccess) => {
    setShowModal(false);
    if (purchaseSuccess && !personalAccount) {
      // Refresh subscription data so "Subscribed" status shows immediately
      setLoading(true);
      await getSubscriptionDetails();
      await getSubscriptionPackageDetails();
      await loadSubscriptions();
      setLoading(false);
    }
  };

  const handlePayment = async (obj) => {
    trackEvent("Select Package Clicked From Team", {
      package_id: obj.id,
      package_name: obj.name,
      price: obj.price,
      duration: obj.duration,
      source: window.location.pathname,
      timestamp: new Date().toISOString(),
    });

    let price = obj.id === 5 ? obj.price_monthly : obj.price;
    let couponCode = null;
    let couponCodeId = null;
    let discount = 0;
    let discountAmount = 0;
    let originalAmount = price;

    if (couponData && couponData.package_id === obj.id && couponData.coupons_applied_status) {
      couponCode = couponData?.coupon_code;
      couponCodeId = couponData?.coupon_code_id;
      discount = couponData?.discount_percentage;
      discountAmount = couponData?.discount_amt;
      price = couponData?.package_price_after_discount;
      originalAmount = couponData?.package_price;
    }

    if (Number(price) === 0) {
      setLoading(true);
      try {
        const paymentObj = {
          amount: 0,
          auto_renew: false,
          duration: obj.duration,
          package_id: obj.id,
          coupon_code: couponCode,
          coupon_code_id: couponCodeId,
          discount: discount,
          discount_amount: discountAmount,
          original_amount: originalAmount,
          subscription_type: "monthly",
        };

        const isIndividual =
          [1, 2, 3].includes(obj.id) ||
          obj.package_type === "customer_specific_personal";
        const endpoint = isIndividual
          ? "individualUserProcessPayment"
          : "processPayment";

        let { status, message } = await post(
          `${TRANSACTION}/${endpoint}`,
          paymentObj,
          Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
        );

        if (!status) {
          setLoading(false);
          showToast(false, message);
          return;
        }

        let paymentMessage = message;
        let userRes = await get(
          GET_USER,
          Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
        );

        if (userRes.status) {
          if (Object.keys(userRes.data).length > 0) {
            userRes.data.token = loggedUser.token;
            userRes.data = normalizePackageDetails(userRes.data);
            setLoggedUser(userRes.data);
            userActions(userRes.data);
            showToast(true, paymentMessage);
            if (personalAccount) {
              setLoading(false);
              navigate("/");
            } else {
              setIsOwnerPackageActive(true);
              // Refresh subscription data on page so "Subscribed" status shows immediately
              let teamPackage = null;
              if (userTeamId) {
                teamPackage = userRes.data.package_details.find(
                  (pkg) => pkg.team_id == userTeamId
                );
              }
              if (!teamPackage && userRes.data.teams?.id) {
                teamPackage = userRes.data.package_details.find(
                  (pkg) => pkg.team_id == userRes.data.teams.id
                );
              }
              if (!teamPackage) {
                teamPackage = userRes.data.package_details.find(
                  (pkg) => pkg.team_id !== null
                );
              }
              if (!teamPackage) {
                teamPackage = userRes.data.package_details.find(
                  (pkg) => pkg.is_team_owner === 1
                );
              }
              // ownedpackageId is now derived from teamPurchasedPackage atom
              await getSubscriptionPackageDetails();
              await loadSubscriptions();
              setLoading(false);
            }
          }
        } else {
          setLoading(false);
          showToast(userRes.status, userRes.message);
          navigate("/");
        }
      } catch (err) {
        setLoading(false);
        showToast(false, err.message || "Something went wrong");
      }
    } else {
      setSelectedPackage(obj);
      setShowModal(true);
    }
  };

  const handlePersonalAccount = () => {
    let teamPackage = loggedUser?.package_details?.find(
      (obj) => obj.team_id == null
    );

    setIsOwnerPackageActive(false);
    setPurchasedPackage(teamPackage?.package || teamPackage);
    setUserTeamId(null);
    setPersonalAccount(true);
    setUserID(null);
    navigate("/");
  };

  const checkExpire = () => {
    // Primary: use teamPurchasedPackage atom (persisted, set from fresh API data)
    // This avoids stale end_date from loggedUser.package_details and survives reloads
    const activePackage = teamPurchasedPackage && teamPurchasedPackage.id
      ? teamPurchasedPackage
      : (purchasedPackage && purchasedPackage.id ? purchasedPackage : null);

    if (activePackage) {
      const endDate = activePackage.end_date;
      if (!endDate) return true; // no end_date = never expires
      let parsed;
      if (/^\d{4}-\d{2}-\d{2}$/.test(endDate)) {
        parsed = new Date(endDate + "T23:59:59");
      } else {
        parsed = new Date(endDate);
      }
      // If parsed is invalid or epoch (bad backend data), treat as valid
      if (isNaN(parsed.getTime()) || parsed.getFullYear() < 2000) return true;
      return parsed > new Date();
    }

    // Fallback: use loggedUser.package_details
    if (!loggedUser?.package_details) return false;

    let teamPackage = null;
    if (userTeamId) {
      teamPackage = loggedUser.package_details.find(
        (obj) => obj.team_id == userTeamId
      );
    }
    if (!teamPackage && loggedUser.teams?.id) {
      teamPackage = loggedUser.package_details.find(
        (obj) => obj.team_id == loggedUser.teams.id
      );
    }
    if (!teamPackage) {
      teamPackage = loggedUser.package_details.find(
        (obj) => obj.team_id !== null
      );
    }
    if (!teamPackage) {
      teamPackage = loggedUser.package_details.find(
        (obj) => obj.is_team_owner === 1
      );
    }

    if (!teamPackage) return false;
    if (!teamPackage.end_date) return true;

    let endDateStr = teamPackage.end_date;
    let endDate;
    if (/^\d{4}-\d{2}-\d{2}$/.test(endDateStr)) {
      endDate = new Date(endDateStr + "T23:59:59");
    } else {
      endDate = new Date(endDateStr);
    }
    if (isNaN(endDate.getTime()) || endDate.getFullYear() < 2000) return true;
    return endDate > new Date();
  };
  const handleCloseCancelModal = () => {
    setShowCancelModal(false);
  };

  const handleCancelSubscription = () => {
    setShowCancelModal(true);
  };

  const handleConfirmDelete = async () => {
    const payload = {
      device_type: "web",
      team_id: userTeamId,
    };
    let { status, message, data } = await post(
      CANCEL_SUBSCRIPTION,
      payload,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    if (status) {
      trackEvent("Subscription Cancelled From Team", {
        outcome: "Success",
        message,
        package_id: data?.package_id || null,
        package_name: data?.package?.package_name || null,
        subscription_data: data,
        timestamp: new Date().toISOString(),
      });
      setPurchasedPackage(data.package);
      showToast(true, message);
      loadSubscriptions();
      getSubscriptionDetails();
      getSubscriptionPackageDetails();
      setShowCancelModal(false);
      navigate("/paymentNotPaid");
    } else {
      showToast(false, message);
    }
    setLoading(false);
  };
  return (
    <>
      <div className="">
        <div className="d-flex flex-md-row flex-column align-items-center justify-content-between p-3">
          <div>
            {location.pathname === "/subscription" && (
              <div className="skipBtnWrapper">
                <Button variant="primary" onClick={handleLogout}>
                  Logout
                </Button>
              </div>
            )}
          </div>

          <div className="heading">
            <h1 className="mb-0">Subscription Plans</h1>
          </div>

          <div >
            {!personalAccount && (
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() => navigate("/")}
              >
                Back
              </Button>
            )}
            
            {location.pathname === "/subscription" &&
              loggedUser?.role?.includes("team_owner") &&
              personalAccount && (
                <div className="skipBtnWrapper">
                  <button onClick={() => navigate("/")}>Go Back</button>
                </div>
              )}
          </div>
        </div>
        <div className="mainWrapper-subs">
          {purchasedPackage?.id !== 1 ? (
            <div className="cardsWrapper">
              {formattedDate !== "Invalid Date" ? (
                <div className="card py-3 mb-4">
                  {purchasedPackage?.end_date !== null ? (
                    <p className="noteText text-center">
                      {isExpired
                        ? `Your subscription has expired on ${formattedDate}`
                        : `Your purchased package will end on ${formattedDate}`}
                    </p>
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                ""
              )}
            </div>
          ) : (
            ""
          )}
          <div
            className="row"
            // style={{
            //   gridTemplateColumns: "repeat(auto-fit, minmax(0, 330px))",
            //   justifyContent: "center",
            // }}
          >
            {subscriptions.length !== 0
              ? subscriptions
                  .filter((singlePackage) => singlePackage.status === 1)
                  .map((singlePackage, index) => (
                    <div
                      className="col-12 col-md-6 col-lg-4 col-xxl-3"
                      key={`pricingCard${index}`}
                    >
                      <Card
                        // style={{ padding: "20px 25px" }}
                        className={`subscriptionCard h-100`}
                      >
                        <div className="card-header">
                          <Card.Title className="text-start">
                            {singlePackage.package_name}
                          </Card.Title>
                          <p className="d-flex align-items-center justify-content-between">
                            {couponData.package_id === singlePackage.id
                              ? `$${couponData.package_price_after_discount}/month`
                              : singlePackage.id === 6
                              ? "Custom Price"
                              : singlePackage.id === 5
                              ? `$${singlePackage.price_monthly}/month`
                              : `$${singlePackage.price}/${singlePackage.duration_type}`}
                            {/* {isActive ? (
                              <span>
                                <FaCheckCircle /> Active
                              </span>
                            ) : (
                              ""
                            )} */}
                          </p>
                        </div>
                        <Card.Body>
                          <ul className="package-features-list list-unstyled">
                            {/* Connection */}
                            {singlePackage.limit_connections_save === 0 ? (
                              <li>
                                <p>Connections</p>
                                <span>
                                  {singlePackage.limit_connections_save}
                                </span>
                              </li>
                            ) : (
                              <li>
                                <p>Connections</p>
                                <span>
                                  {singlePackage.limit_connections_save}
                                </span>
                              </li>
                            )}
                            {/*  Card Section */}
                            {singlePackage.limit_card_create === 0 ? (
                              <li>
                                <p>Personal/Business Card</p>
                                <span>{singlePackage.limit_card_create}</span>
                              </li>
                            ) : singlePackage.id === 1 ? (
                              <li>
                                <p>Personal/Business Card</p>
                                <span></span>
                              </li>
                            ) : (
                              <li>
                                <p>Personal/Business Card</p>
                                <span>{singlePackage.limit_card_create}</span>
                              </li>
                            )}

                            {/* Payments */}
                            {singlePackage.limit_payment_create == 0 ? (
                              <li>
                                <p>Payments cards</p>
                                <span>
                                  {singlePackage.limit_payment_create}
                                </span>
                              </li>
                            ) : singlePackage.id === 1 ? (
                              <li>
                                <p>Payments cards</p>
                                <span></span>
                              </li>
                            ) : (
                              <li>
                                <p>Payments cards</p>
                                <span>
                                  {singlePackage.limit_payment_create}
                                </span>
                              </li>
                            )}

                            {/* Emergency Contact */}
                            {singlePackage.limit_emergency_contact_create ==
                            0 ? (
                              <li>
                                <p>Emergency Contacts</p>
                                <span>
                                  {singlePackage.limit_emergency_contact_create}
                                </span>
                              </li>
                            ) : singlePackage.id === 1 ? (
                              <li>
                                <p>Emergency Contacts</p>
                                <span></span>
                              </li>
                            ) : (
                              <li>
                                <p>Emergency Contacts</p>
                                <span>
                                  {singlePackage.limit_emergency_contact_create}
                                </span>
                              </li>
                            )}

                            {/* Custom Url */}
                            {singlePackage.limit_custom_url_create == 0 ? (
                              <li>
                                <p>Custom URL</p>
                                <span>
                                  {singlePackage.limit_custom_url_create}
                                </span>
                              </li>
                            ) : singlePackage.id === 1 ? (
                              <li>
                                <p>Custom URL</p>
                                <span></span>
                              </li>
                            ) : (
                              <li>
                                <p>Custom URL</p>
                                <span>
                                  {singlePackage.limit_custom_url_create}
                                </span>
                              </li>
                            )}

                            {/* File Upload Url */}
                            {singlePackage.limit_file_upload_create == 0 ? (
                              <li>
                                <p>File Upload URL</p>
                                <span>
                                  {singlePackage.limit_file_upload_create}
                                </span>
                              </li>
                            ) : singlePackage.id === 1 ? (
                              <li>
                                <p>File Upload URL</p>
                                <span></span>
                              </li>
                            ) : (
                              <li>
                                <p>File Upload URL</p>
                                <span>
                                  {singlePackage.limit_file_upload_create}
                                </span>
                              </li>
                            )}
                            {singlePackage.limit_memory == 0 ? (
                              <li>
                                <p>Memory</p>
                                <span>{singlePackage.limit_memory}</span>
                              </li>
                            ) : singlePackage.id === 1 ? (
                              <li>
                                <p>Memory</p>
                                <span></span>
                              </li>
                            ) : (
                              <li>
                                <p>Memory</p>
                                <span>{singlePackage.limit_memory}</span>
                              </li>
                            )}
                            {singlePackage.limit_form_builder == 0 ? (
                              <li>
                                <p>Lead Builder</p>
                                <span>{singlePackage.limit_form_builder}</span>
                              </li>
                            ) : singlePackage.id === 1 ? (
                              <li>
                                <p>Lead Builder</p>
                                <span></span>
                              </li>
                            ) : (
                              <li>
                                <p>Lead Builder</p>
                                <span>{singlePackage.limit_form_builder}</span>
                              </li>
                            )}

                            {singlePackage.limit_medical_id == 0 ? (
                              <li>
                                <p>Medical ID</p>
                                <span>{singlePackage.limit_medical_id}</span>
                              </li>
                            ) : singlePackage.id === 1 ? (
                              <li>
                                <p>Medical ID</p>
                                <span></span>
                              </li>
                            ) : (
                              <li>
                                <p>Medical ID</p>
                                <span>{singlePackage.limit_medical_id}</span>
                              </li>
                            )}

                            {singlePackage.id === 1 &&
                            singlePackage.limit_dynamic_qr_code == 0 ? (
                              <li>
                                <p>Dynamic QR Code</p>
                                <span></span>
                              </li>
                            ) : singlePackage.limit_dynamic_qr_code == 0 ? (
                              <li>
                                <p>Dynamic QR Code</p>
                                <span>
                                  {singlePackage.limit_dynamic_qr_code}
                                </span>
                              </li>
                            ) : (
                              <li>
                                <p>Dynamic QR Code</p>
                                <span>
                                  {singlePackage.limit_dynamic_qr_code}
                                </span>
                              </li>
                            )}

                            {singlePackage.limit_dynamic_qr_code == 0 ? (
                              <li>
                                <p>Dynamic QR Code Function Limit</p>
                                <span>
                                  {singlePackage.limit_dynamic_qr_code}
                                </span>
                              </li>
                            ) : singlePackage.id === 1 ? (
                              <li>
                                <p>Dynamic QR Code Function Limit</p>
                                <span></span>
                              </li>
                            ) : (
                              <li>
                                <p>Dynamic QR Code Function Limit</p>
                                <span>
                                  {singlePackage.limit_dynamic_qr_code}
                                </span>
                              </li>
                            )}

                            {/*Custom Button */}
                            {singlePackage.enable_custom_buttons == 0 ? (
                              <li>
                                <p>Custom Button</p>
                                <span>
                                  {singlePackage.enable_custom_buttons
                                    ? "Yes"
                                    : "No"}
                                </span>
                              </li>
                            ) : (
                              <li>
                                <p>Custom Button</p>
                                <span>
                                  {singlePackage.enable_custom_buttons
                                    ? "Yes"
                                    : "No"}
                                </span>
                              </li>
                            )}
                            {singlePackage.user_limit > 0 && (
                              <li>
                                <p>Maximum User Limit</p>
                                <span>{singlePackage.user_limit}</span>
                              </li>
                            )}
                            {singlePackage.price_per_user_after_limit == 0 ? (
                              <li>
                                <p>Pay Per Person</p>
                                <span>
                                  {singlePackage.price_per_user_after_limit}
                                </span>
                              </li>
                            ) : (
                              <li>
                                <p>Pay Per Person</p>
                                <span>
                                  {singlePackage.price_per_user_after_limit}
                                </span>
                              </li>
                            )}
                          </ul>
                        </Card.Body>
                        {/* <button className="subscriptionType">
                          {singlePackage.package_name}
                        </button> */}
                        {/* <div className="imgWrapper">
                          <img
                            src={
                              singlePackage.package_name === "Starter"
                                ? basicIcon
                                : singlePackage.package_name === "Premium"
                                ? proIcon
                                : singlePackage.id === 6
                                ? enterpriseIcon
                                : premiumIcon
                            }
                            alt=""
                          />
                        </div> */}

                        {/* <h3 className={classes.title}>
                       {singlePackage.id === 6
                         ? "Custom Price"
                         : singlePackage.id === 5
                         ? `$${singlePackage.price_monthly}/month`
                         : `$${singlePackage.price}/${singlePackage.duration_type}`}
                     </h3> */}
                        {/* <h3 className="title">
                          {couponData.package_id === singlePackage.id
                            ? `$${couponData.package_price_after_discount}/month`
                            : singlePackage.id === 6
                            ? "Custom Price"
                            : singlePackage.id === 5
                            ? `$${singlePackage.price_monthly}/month`
                            : `$${singlePackage.price}/${singlePackage.duration_type}`}
                        </h3> */}
                        {/* <ul className="list" style={{ color: "#333333" }}>
                          {singlePackage.limit_card_create == 0 ? (
                            <li>
                              <div
                                className="d-flex align-items-center justify-content-between"
                                style={{ color: "#333333" }}
                              >
                                <p>Personal/Business Card</p>
                                <p>{singlePackage.limit_card_create}</p>
                              </div>
                            </li>
                          ) : (
                            <li>
                              <div className="d-flex align-items-center justify-content-between">
                                <p>Personal/Business Card</p>
                                <p>{singlePackage.limit_card_create}</p>
                              </div>
                            </li>
                          )}

                          {singlePackage.limit_connections_save == 0 ? (
                            <li>
                              <div
                                className="d-flex align-items-center justify-content-between"
                                style={{ color: "var(--primary_text_color)" }}
                              >
                                <p>Connections</p>
                                <p>{singlePackage.limit_connections_save}</p>
                              </div>
                            </li>
                          ) : (
                            <li>
                              <div className="d-flex align-items-center justify-content-between">
                                <p>Connections</p>
                                <p>{singlePackage.limit_connections_save}</p>
                              </div>
                            </li>
                          )}
                          {singlePackage.limit_payment_create == 0 ? (
                            <li>
                              <div
                                className="d-flex align-items-center justify-content-between"
                                style={{ color: "var(--primary_text_color)" }}
                              >
                                <p>Payments cards</p>
                                <p>{singlePackage.limit_payment_create}</p>
                              </div>
                            </li>
                          ) : (
                            <li>
                              <div className="d-flex align-items-center justify-content-between">
                                <p>Payments cards</p>
                                <p>{singlePackage.limit_payment_create}</p>
                              </div>
                            </li>
                          )}

                          {singlePackage.limit_emergency_contact_create == 0 ? (
                            <li>
                              <div
                                className="d-flex align-items-center justify-content-between"
                                style={{ color: "var(--primary_text_color)" }}
                              >
                                <p>Emergency Contacts</p>
                                <p>
                                  {singlePackage.limit_emergency_contact_create}
                                </p>
                              </div>
                            </li>
                          ) : (
                            <li>
                              <div className="d-flex align-items-center justify-content-between">
                                <p>Emergency Contacts</p>
                                <p>
                                  {singlePackage.limit_emergency_contact_create}
                                </p>
                              </div>
                            </li>
                          )}
                          {singlePackage.limit_custom_url_create == 0 ? (
                            <li>
                              <div
                                className="d-flex align-items-center justify-content-between"
                                style={{ color: "var(--primary_text_color)" }}
                              >
                                <p>Custom URL</p>
                                <p>{singlePackage.limit_custom_url_create}</p>
                              </div>
                            </li>
                          ) : (
                            <li>
                              <div className="d-flex align-items-center justify-content-between">
                                <p>Custom URL</p>
                                <p>{singlePackage.limit_custom_url_create}</p>
                              </div>
                            </li>
                          )}
                          {singlePackage.limit_file_upload_create == 0 ? (
                            <li>
                              <div
                                className="d-flex align-items-center justify-content-between"
                                style={{ color: "var(--primary_text_color)" }}
                              >
                                <p>File Upload URL</p>
                                <p>{singlePackage.limit_file_upload_create}</p>
                              </div>
                            </li>
                          ) : (
                            <li>
                              <div className="d-flex align-items-center justify-content-between">
                                <p>File Upload URL</p>
                                <p>{singlePackage.limit_file_upload_create}</p>
                              </div>
                            </li>
                          )}
                          {singlePackage.limit_memory == 0 ? (
                            <li>
                              <div
                                className="d-flex align-items-center justify-content-between"
                                style={{ color: "var(--primary_text_color)" }}
                              >
                                <p>Memory</p>
                                <p>{singlePackage.limit_memory}</p>
                              </div>
                            </li>
                          ) : (
                            <li>
                              <div className="d-flex align-items-center justify-content-between">
                                <p>Memory</p>
                                <p>{singlePackage.limit_memory}</p>
                              </div>
                            </li>
                          )}
                          {singlePackage.limit_form_builder == 0 ? (
                            <li>
                              <div
                                className="d-flex align-items-center justify-content-between"
                                style={{ color: "var(--primary_text_color)" }}
                              >
                                <p>Lead Builder</p>
                                <p>{singlePackage.limit_form_builder}</p>
                              </div>
                            </li>
                          ) : (
                            <li>
                              <div className="d-flex align-items-center justify-content-between">
                                <p>Lead Builder</p>
                                <p>{singlePackage.limit_form_builder}</p>
                              </div>
                            </li>
                          )}

                          {singlePackage.limit_medical_id == 0 ? (
                            <li>
                              <div
                                className="d-flex align-items-center justify-content-between"
                                style={{ color: "var(--primary_text_color)" }}
                              >
                                <p>Medical ID</p>
                                <p>{singlePackage.limit_medical_id}</p>
                              </div>
                            </li>
                          ) : singlePackage.id === 1 ? (
                            <li>
                              <div className="d-flex align-items-center justify-content-between">
                                <p>Medical ID</p>
                                <p></p>
                              </div>
                            </li>
                          ) : (
                            <li>
                              <div className="d-flex align-items-center justify-content-between">
                                <p>Medical ID</p>
                                <p>{singlePackage.limit_medical_id}</p>
                              </div>
                            </li>
                          )}

                          {singlePackage.limit_dynamic_qr_code == 0 ? (
                            <li>
                              <div
                                className="d-flex align-items-center justify-content-between"
                                style={{ color: "var(--primary_text_color)" }}
                              >
                                <p>Dynamic QR Code</p>
                                <p>{singlePackage.limit_dynamic_qr_code}</p>
                              </div>
                            </li>
                          ) : singlePackage.id === 1 ? (
                            <li>
                              <div className="d-flex align-items-center justify-content-between">
                                <p>Dynamic QR Code</p>
                                <p></p>
                              </div>
                            </li>
                          ) : (
                            <li>
                              <div className="d-flex align-items-center justify-content-between">
                                <p>Dynamic QR Code</p>
                                <p>{singlePackage.limit_dynamic_qr_code}</p>
                              </div>
                            </li>
                          )}

                          {singlePackage.limit_dynamic_qr_code == 0 ? (
                            <li>
                              <div
                                className="d-flex align-items-center justify-content-between"
                                style={{ color: "var(--primary_text_color)" }}
                              >
                                <p>Dynamic QR Code Function Limit</p>
                                <p>{singlePackage.limit_dynamic_qr_code}</p>
                              </div>
                            </li>
                          ) : singlePackage.id === 1 ? (
                            <li>
                              <div className="d-flex align-items-center justify-content-between">
                                <p>Dynamic QR Code Function Limit</p>
                                <p></p>
                              </div>
                            </li>
                          ) : (
                            <li>
                              <div className="d-flex align-items-center justify-content-between">
                                <p>Dynamic QR Code Function Limit</p>
                                <p>{singlePackage.limit_dynamic_qr_code}</p>
                              </div>
                            </li>
                          )}

                          {singlePackage.enable_custom_buttons == 0 ? (
                            <li>
                              <div
                                className="d-flex align-items-center justify-content-between"
                                style={{ color: "var(--primary_text_color)" }}
                              >
                                <p>Custom Button</p>
                                <p>
                                  {singlePackage.enable_custom_buttons === 0
                                    ? "False"
                                    : "True"}
                                </p>
                              </div>
                            </li>
                          ) : (
                            <li>
                              <div className="d-flex align-items-center justify-content-between">
                                <p>Custom Button</p>
                                <p>
                                  {singlePackage.enable_custom_buttons
                                    ? "True"
                                    : "False"}
                                </p>
                              </div>
                            </li>
                          )}

                          {singlePackage.user_limit > 0 && (
                            <li>
                              <div className="d-flex align-items-center justify-content-between">
                                <p>Maximum User Limit</p>
                                <p>{singlePackage.user_limit}</p>
                              </div>
                            </li>
                          )}
                          {singlePackage.price_per_user_after_limit == 0 ? (
                            <li>
                              <div
                                className="d-flex align-items-center justify-content-between"
                                style={{ color: "var(--primary_text_color)" }}
                              >
                                <p>Pay Per Person</p>
                                <p>
                                  {singlePackage.price_per_user_after_limit}
                                </p>
                              </div>
                            </li>
                          ) : (
                            <li>
                              <div className="d-flex align-items-center justify-content-between">
                                <p>Pay Per Person</p>
                                <p>
                                  {singlePackage.price_per_user_after_limit}
                                </p>
                              </div>
                            </li>
                          )}
                        </ul> */}
                        <Card.Footer>
                          {singlePackage.id == 5 && (
                            <>
                              <div className="couponWrapper mb-3">
                                <div className="form-check text-start">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value=""
                                    id={`couponCheckbox-${singlePackage.id}`}
                                    onChange={() =>
                                      handleCheckboxChange(singlePackage.id)
                                    }
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor={`couponCheckbox-${singlePackage.id}`}
                                  >
                                    Do you have a coupon?
                                  </label>
                                </div>
                                {showCouponInputs[singlePackage.id] && (
                                  <div className="input-group mt-3">
                                    <input
                                      type="text"
                                      className="form-control coupon-form-control"
                                      placeholder="Enter Coupon code"
                                      onChange={handleCouponInputChange}
                                    />
                                    <button
                                      className="btn  btn-outline-secondary"
                                      type="button"
                                      onClick={() =>
                                        applyCoupon("monthly", "5")
                                      }
                                    >
                                      {/* <img src={CouponBtn} alt="" /> */}
                                      <MdSend />
                                    </button>

                                    {blankCouponField && (
                                      <div className="failurText">
                                        Please enter coupon code
                                      </div>
                                    )}
                                    {correctCouponEntered && (
                                      <div className="successText">
                                        Yes, coupon successfully applied
                                      </div>
                                    )}
                                    {incorrectCouponEntered && (
                                      <div className="failurText">
                                        Sorry, coupon code invalid
                                      </div>
                                    )}
                                  </div>
                                )}
                              </div>
                            </>
                          )}

                          {singlePackage.id == 6 ? (
                            <Link
                              to={`/PackageContactForm/${singlePackage.id}`}
                            >
                              <Button
                                variant="primary"
                                onClick={() =>
                                  trackEvent("Contact Us Clicked From Team", {
                                    package_id: singlePackage.id,
                                    package_name:
                                      singlePackage.package_name || "Unknown",
                                    timestamp: new Date().toISOString(),
                                  })
                                }
                              >
                                Contact Us
                              </Button>
                            </Link>
                          ) : (console.log(`[render] pkg=${singlePackage.package_name} id=${singlePackage.id} ownedpackageId=${ownedpackageId} checkExpire=${checkExpire()}`), ownedpackageId == singlePackage.id &&
                            checkExpire()) ? (
                            <>
                              <button className="btn" disabled>
                                Subscribed{" "}
                                <div
                                  style={{
                                    display: "inline",
                                    // backgroundColor: "white",
                                  }}
                                >
                                  <AiFillCheckCircle />
                                </div>
                              </button>
                              {singlePackage.id === 1 ? (
                                ""
                              ) : (
                                <Button
                                  variant="link"
                                  onClick={handleCancelSubscription}
                                >
                                  Cancel Subscription
                                </Button>
                              )}
                            </>
                          ) : (
                            <>
                              <Button
                                variant="primary"
                                onClick={() => handlePayment(singlePackage)}
                              >
                                Select Package
                              </Button>
                            </>
                          )}
                        </Card.Footer>
                      </Card>
                    </div>
                  ))
              : null}
          </div>
        </div>
      </div>
      {showModal && (
        <SubscriptionModal
          show={showModal}
          stripePromise={stripePromise}
          handleCloseModal={handleCloseModal}
          selectedPackage={selectedPackage}
          elementsOptions={elementsOptions}
          couponData={couponData}
        />
      )}
      <Modal
        show={showCancelModal}
        onHide={handleCloseCancelModal}
        aria-labelledby="contained-modal-title-vcenter"
        className="customModal square-modal"
        size="sm"
      >
        <Modal.Header className="modalHeader flex justify-content-between modal-header">
          <div className="modalGradientCircle"></div>
          <MdClose onClick={handleCloseCancelModal} className="modalCloseBtn" />
        </Modal.Header>

        <Modal.Body
          style={{ padding: "0" }}
          className="d-flex justify-content-center flex-column align-items-center p-4"
        >
          <div
            className="d-flex flex-column align-items-center justify-content-center"
            style={{ width: "fit-content", lineHeight: "18px" }}
          >
            <h5>Are you sure?</h5>
            <p
              style={{
                lineHeight: "18px",
                textAlign: "center",
                padding: "0px 20px",
              }}
            >
              Are you sure you want to cancel your Subscription
            </p>
          </div>

          <div className="customModalBtnWrapper btnWrapper mobileViewWrapper px-4">
            <button
              onClick={handleConfirmDelete}
              className="primary_button mt-3"
            >
              Delete
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <style type="text/css">
        {`
       .noteText{
         color: var(--error_color);
         font-size: 12px;
         text-align: left;
         margin-bottom:0;
       }
        .warningText{
         color: #e6ba58;
         font-size: 12px;
         text-align: left;
         margin-bottom:0;
           background:var(--primary_color);
           border-radius: 10px;
           padding: 10px;
       }
      // .cardsWrapper{
      //  display:flex;
      //  flex-wrap:wrap;
      //  gap:0;
      // }
      // .card{
      //  width:32.3333%;
      //  margin-bottom: 15px;
      //  margin-right:1%;
      // }
      // .imgWrapper{
      //  margin-bottom:0;
      // }
      .subscriptionType{
       width:fit-content;
       margin: 0 auto;
      }
    //   .couponWrapper {
    //    background-color: var(--primary_color);
    //    border-radius: 10px;
    //    padding: 15px 25px;
    //    margin: 30px 10px 0 !important;
    //    color:var(--heading_text_color);
    //  }
    //  .form-check-label {
    //    font-size: 13px;
    //    font-weight: 500;
    //        color:var(--heading_text_color);
    //  }
    //  .form-check-input, .form-check-input:focus{
    //    //  background: var(--primary_color);
    //     border: 1px solid var(--border_color);
    //    outline:none
    //   }
    //  .coupon-form-control, .coupon-form-control:focus{
    //    background-color:transparent;
    //    color:var(--heading_text_color);
    //    font-size:13px;
    //    font-weight:700;
    //    border-radius:5rem;
    //    box-shadow:none;
    //  }
    //  .coupon-form-control::placeholder{
    //    color:var(--heading_text_color);
    //  }
    //  .btn-outline-secondary, .btn-outline-secondary:focus{
    //    border-radius:5rem;
    //    border-top-right-radius: 5rem !important;
    //    border-bottom-right-radius: 5rem !important;
    //    background: var(--accent_color) !important;
    //    color:var(--heading_text_color);
    //  }
     .failurText, .successText{
       text-align:left;
       font-size:13px;
       color:#ff0000;
       display: block;
       width: 100%;
     }
     .successText{
       color: #42764e;
     }
     @media only screen and (max-width: 1399.98px) {
       .form-check-label {
         font-size: 12px;
           color:var(--heading_text_color);
       }
     }
    `}
      </style>
    </>
  );
};

export default Subscription;
